import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = 'https://kwdzmwldiyylrapdhzjy.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt3ZHptd2xkaXl5bHJhcGRoemp5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA3NDc2NzcsImV4cCI6MjA1NjMyMzY3N30.bdeS5MwrsFsbZ-RCEqUsFskJVP1oz0izfSPsZkUKudc';

export const supabaseClient = createClient(supabaseUrl, supabaseAnonKey);
